import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = ({ dark = false }) => {
  const { lang, toggleLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2 bg-gray-100 rounded-lg p-1">
      <button
        onClick={() => toggleLanguage('ro')}
        className={`px-2 py-1 text-xs font-bold rounded-md transition-all ${
          lang === 'ro' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        RO
      </button>
      <button
        onClick={() => toggleLanguage('en')}
        className={`px-2 py-1 text-xs font-bold rounded-md transition-all ${
          lang === 'en' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;